export default __webpack_public_path__ + "static/media/dieppe3.de75d17d.jpg";